// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1DZS8","header":"PatientBlock_header__9mduu","label":"PatientBlock_label__UrCHb","option":"PatientBlock_option__2eA3C"};